import { unzipSync, zipSync, strToU8 } from 'fflate';
import { fetchWithAuth, getApiV1BaseUrl } from './secureMedia';

export async function buildBatchedEvidenceArchive({evidenceIds, cutoffDate, unified, onProgress = () => {}}) {
  const ids = [...new Set(evidenceIds.map(Number).filter(id => Number.isInteger(id) && id > 0))];
  if (!ids.length) throw new Error('No hay evidencias para descargar.');
  const files = Object.create(null);
  let completed = 0;
  let batchNumber = 0;
  let evidenceFiles = 0;

  async function fetchBatch(batch) {
    const response = await fetchWithAuth(`${getApiV1BaseUrl()}/meetings/evidences-archive-filtered`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ids: batch, ...(cutoffDate ? {cutoffDate} : {}), ...(unified ? {unified: true} : {})})
    });
    // A smaller batch can finish within the proxy's timeout. Never retry auth failures.
    if ([502, 504].includes(response.status) && batch.length > 1) {
      const middle = Math.ceil(batch.length / 2);
      await fetchBatch(batch.slice(0, middle));
      await fetchBatch(batch.slice(middle));
      return;
    }
    if (!response.ok) {
      throw new Error(`No se pudo descargar el lote de encuentros ${batch.join(', ')} (HTTP ${response.status}). Intenta nuevamente o reduce la selección.`);
    }
    const entries = unzipSync(new Uint8Array(await response.arrayBuffer()));
    batchNumber += 1;
    for (const [path, bytes] of Object.entries(entries)) {
      if (path.endsWith('/')) continue;
      if (path.split('/').some(part => part === '..' || part === '.') || path.startsWith('/') || path.includes('\\')) {
        throw new Error('El archivo recibido contiene una ruta inválida.');
      }
      let target = path === 'README.txt' ? `Informacion_descarga/lote_${batchNumber}.txt` : path;
      const base = target;
      let suffix = 2;
      while (Object.prototype.hasOwnProperty.call(files, target)) {
        const dot = base.lastIndexOf('.');
        target = dot > base.lastIndexOf('/')
          ? `${base.slice(0, dot)}_${suffix++}${base.slice(dot)}`
          : `${base}_${suffix++}`;
      }
      files[target] = bytes;
      if (path !== 'README.txt') evidenceFiles += 1;
    }
    completed += batch.length;
    onProgress(completed, ids.length);
  }

  onProgress(0, ids.length);
  for (let offset = 0; offset < ids.length; offset += 5) {
    await fetchBatch(ids.slice(offset, offset + 5));
  }
  if (!evidenceFiles) throw new Error('No se encontraron archivos de evidencia para descargar.');
  files['README.txt'] = strToU8([
    'Consolidado de evidencias',
    `Encuentros solicitados: ${ids.length}`,
    `Archivos de evidencia: ${evidenceFiles}`,
    `Fecha de corte: ${cutoffDate || 'Fecha de generación (ver detalle por lote)'}`,
    `PDF unificado por encuentro: ${unified ? 'Sí' : 'No'}`,
    'El detalle de generación de cada lote está en Informacion_descarga.'
  ].join('\n'));
  return new Blob([zipSync(files, {level: 0})], {type: 'application/zip'});
}
